import styled from '@emotion/styled'

import { overrideOptional } from '@emico/overrides'

const TableRow = styled.tr``

export default overrideOptional(TableRow)
